import React from "react";
import classnames from "classnames/bind";

import css from "./index.scss";
import headerImg from "./assets/BoardDetail_test2.jpeg";

const cx = classnames.bind(css);
const moduleName = "Reservation";

const INFO_SECTIONS = [
  {
    en: "Pricing",
    title: "요금 안내",
    items: [
      "성수기와 비성수기 요금이 상이합니다.",
      "정확한 요금은 펜션지기에게 문의해 주세요.",
      "Tel: 010-4738-6659",
    ],
  },
  {
    en: "Peak Season",
    title: "성수기 안내",
    items: [
      "성수기: 7월 25일 — 8월 15일",
      "성수기와 비성수기 요금이 상이합니다.",
      "사전 문의를 권장합니다.",
    ],
  },
  {
    en: "Cancellation",
    title: "취소 및 환불",
    items: [
      "이용일 20일 전: 90% 환불",
      "이용일 7일 전: 70% 환불",
      "이용일 4~6일 전: 50% 환불",
      "이용일 3일 전 ~ 당일: 환불 불가",
    ],
  },
  {
    en: "Checklist",
    title: "이용 안내",
    items: [
      "입실 PM 03:00 / 퇴실 AM 11:00",
      "소등 권장 시간: 오후 10시 30분",
      "바베큐 숯불·그릴 이용: 1회 20,000원",
      "픽업 서비스: 예약 시 사전 요청 필요",
    ],
  },
];

const Reservation = () => (
  <div className={cx(moduleName)}>
    {/* Hero header */}
    <div className={cx(`${moduleName}-hero`)}>
      <img src={headerImg} alt="reservation" className={cx(`${moduleName}-hero-img`)} />
      <div className={cx(`${moduleName}-hero-overlay`)} />
      <div className={cx(`${moduleName}-hero-content`)}>
        <p className={cx(`${moduleName}-hero-label`)}>Reservation</p>
        <h2>예약 안내</h2>
        <p className={cx(`${moduleName}-hero-sub`)}>소중한 여행, 미리 준비하세요</p>
      </div>
    </div>

    {/* Contact strip */}
    <div className={cx(`${moduleName}-strip`)}>
      <div className={cx(`${moduleName}-strip-item`)}>
        <span className={cx(`${moduleName}-strip-label`)}>Tel</span>
        <a href="tel:01047386659" className={cx(`${moduleName}-strip-value`)}>010 · 4738 · 6659</a>
      </div>
      <div className={cx(`${moduleName}-strip-divider`)} />
      <div className={cx(`${moduleName}-strip-item`)}>
        <span className={cx(`${moduleName}-strip-label`)}>Check-in</span>
        <span className={cx(`${moduleName}-strip-value`)}>PM 03:00</span>
      </div>
      <div className={cx(`${moduleName}-strip-divider`)} />
      <div className={cx(`${moduleName}-strip-item`)}>
        <span className={cx(`${moduleName}-strip-label`)}>Check-out</span>
        <span className={cx(`${moduleName}-strip-value`)}>AM 11:00</span>
      </div>
    </div>

    {/* Info grid */}
    <div className={cx(`${moduleName}-grid`)}>
      {INFO_SECTIONS.map((sec, i) => (
        <div key={i} className={cx(`${moduleName}-card`)} data-aos="fade-up" data-aos-delay={i * 80}>
          <span className={cx(`${moduleName}-card-en`)}>{sec.en}</span>
          <h3 className={cx(`${moduleName}-card-title`)}>{sec.title}</h3>
          <div className={cx(`${moduleName}-card-line`)} />
          <ul className={cx(`${moduleName}-card-list`)}>
            {sec.items.map((item, j) => (
              <li key={j}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);

export default Reservation;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Reservation/index.js